import React from 'react';
import { FaWhatsapp, FaInstagram, FaYoutube, FaLinkedin, FaEnvelope, FaLink } from "react-icons/fa";
import { motion } from "framer-motion";
import { useTheme } from '../context/ThemeContext';
import logo from '../assets/minilogo.png';

const Socialicon = () => {
  useTheme();

  const c = {
    bg: 'var(--bg-main)',
    card: 'var(--bg-card)',
    cardHover: 'var(--bg-surface)',
    border: 'var(--border)',
    text: 'var(--text-main)',
    muted: 'var(--text-muted)',
    accent: 'var(--accent)',
  };

  const socialLinks = [
    {
      title: "WhatsApp Community 1",
      icon: <FaWhatsapp size={24} />,
      url: "https://chat.whatsapp.com/DHMLVsB0wdeDLAl4MZH06P?mode=ac_t",
      description: "Join our main community for discussions"
    },
    {
      title: "WhatsApp Community 2",
      icon: <FaWhatsapp size={24} />,
      url: "https://chat.whatsapp.com/BcJOVpVibwKEU3kjVsYLJ3?mode=ac_t",
      description: "Join our announcements channel"
    },
    {
      title: "Instagram",
      icon: <FaInstagram size={24} />,
      url: "https://www.instagram.com/snapedcodecampus?igsh=aWdxY2NjdmN0c2N1",
      description: "Follow us for live updates"
    },
    {
      title: "YouTube",
      icon: <FaYoutube size={24} />,
      url: "https://youtube.com/@snapedcodecampus?si=9LJ0YrqQ4nPXPAN-",
      description: "Subscribe for curated tutorials"
    },
    {
      title: "LinkedIn",
      icon: <FaLinkedin size={24} />,
      url: "https://www.linkedin.com/company/snaped-code-campus/",
      description: "Connect with us professionally"
    },
    {
      title: "Email Us",
      icon: <FaEnvelope size={24} />,
      url: "mailto:snaped4338@gmail.com",
      description: "Send us a direct inquiry"
    },
    {
      title: "Website",
      icon: <FaLink size={24} />,
      url: "https://snapedcodecampus.tech/",
      description: "Discover all our platforms"
    }
  ];

  return (
    <div style={{ minHeight: '100vh', background: c.bg, color: c.text, position: 'relative', overflow: 'hidden' }}>
      {/* Decorative Glows */}
      <div style={{ position: 'absolute', top: '-10%', left: '20%', width: '60vw', height: '60vw', background: 'radial-gradient(circle, var(--accent) 0.08, transparent 70%)', filter: 'blur(80px)', pointerEvents: 'none', opacity: 0.1 }} />
      <div style={{ position: 'absolute', bottom: '-10%', right: '10%', width: '40vw', height: '40vw', background: 'radial-gradient(circle, var(--accent) 0.05, transparent 70%)', filter: 'blur(60px)', pointerEvents: 'none', opacity: 0.1 }} />

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '100px 24px 80px', position: 'relative', zIndex: 1 }}>
        {/* Header Section */}
        <motion.div
          style={{ textAlign: 'center', marginBottom: 64 }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.div
            whileHover={{ scale: 1.05 }}
            style={{
              width: 96, height: 96, borderRadius: 28,
              background: 'rgba(255,255,255,0.02)',
              border: `1px solid ${c.border}`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              margin: '0 auto 32px',
              padding: 20,
              boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
              position: 'relative'
            }}
          >
            <div style={{ position: 'absolute', inset: 0, background: 'radial-gradient(circle, rgba(34,197,94,0.15) 0%, transparent 70%)', borderRadius: 'inherit' }} />
            <img
              src={logo}
              alt="SnapED Logo"
              style={{ width: '100%', height: '100%', objectFit: 'contain', position: 'relative' }}
            />
          </motion.div>

          <h2 style={{ fontSize: 'clamp(2rem, 5vw, 3.5rem)', fontWeight: 900, letterSpacing: '-0.04em', margin: '0 0 16px', lineHeight: 1.1 }}>
            SnapED <span style={{ color: c.accent }}>codeCampus</span>
          </h2>

          <p style={{ fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', color: c.muted, lineHeight: 1.6, maxWidth: 480, margin: '0 auto', fontWeight: 500 }}>
            Join our communities and stay updated with the latest tech news, tutorials, and discussions.
          </p>
        </motion.div>

        {/* Social Links List */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
          {socialLinks.map((link, index) => (
            <motion.a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
              whileHover={{ scale: 1.01, x: 4, backgroundColor: 'rgba(255,255,255,0.05)' }}
              whileTap={{ scale: 0.99 }}
              style={{
                display: 'flex', alignItems: 'center', gap: 20,
                padding: '20px 24px',
                background: c.card,
                border: `1px solid ${c.border}`,
                borderRadius: 20,
                textDecoration: 'none',
                transition: 'all 0.3s ease',
                backdropFilter: 'blur(12px)',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
              }}
            >
              <div style={{
                width: 52, height: 52, borderRadius: 14,
                background: 'rgba(34,197,94,0.1)',
                border: '1px solid rgba(34,197,94,0.2)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: c.accent, flexShrink: 0,
                boxShadow: '0 0 15px rgba(34,197,94,0.1)'
              }}>
                {link.icon}
              </div>
              <div style={{ flex: 1 }}>
                <h3 style={{ margin: '0 0 2px', fontSize: '1.05rem', fontWeight: 800, color: 'var(--text-main)', letterSpacing: '-0.01em' }}>{link.title}</h3>
                <p style={{ margin: 0, fontSize: '0.85rem', color: 'var(--text-muted)', fontWeight: 500 }}>{link.description}</p>
              </div>
              <div style={{ color: 'rgba(255,255,255,0.15)', transition: 'all 0.3s ease' }}>
                <FaLink size={18} />
              </div>
            </motion.a>
          ))}
        </div>

        {/* Footer Text */}
        <motion.div
          style={{ marginTop: 64, textAlign: 'center', color: 'var(--text-muted)', fontSize: '0.8rem', fontWeight: 600, letterSpacing: '0.1em', textTransform: 'uppercase', opacity: 0.5 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1 }}
        >
          Connect with us on all platforms
        </motion.div>
      </div>

      {/* <Footer /> */}
    </div>
  );
}

export default Socialicon;